import Highcharts from "highcharts";

declare module "highcharts" {
  interface Series {
    findPointIndex(
      optionsObject: Highcharts.PointOptionsObject,
      fromIndex: number,
    ): number | undefined;
    cropped?: unknown;
    linkedParent?: unknown;
    enabledDataSorting?: unknown;
    xData: number[];
  }

  interface Point {
    touched?: unknown;
  }
}

// Do not use Chart.prototype.get (terrible performance)
// wraps https://github.com/highcharts/highcharts/blob/master/ts/Core/Series/Series.ts#L3446
export default function findPointIndex(H: typeof Highcharts) {
  H.wrap(
    Highcharts.Series.prototype,
    "findPointIndex",
    function (
      this: Highcharts.Series,
      proceed: typeof Highcharts.Series.prototype.findPointIndex,
      ...args: Parameters<typeof Highcharts.Series.prototype.findPointIndex>
    ) {
      const optionsObject = args[0];
      const x = optionsObject.x;
      const fromIndex = args[1];
      if (
        this.cropped ||
        this.linkedParent ||
        this.enabledDataSorting ||
        x === undefined ||
        !Highcharts.isNumber(x)
      )
        return proceed.apply(this, args);
      const pointIndex = this.xData.indexOf(x, fromIndex);
      if (this.points[pointIndex]?.touched) return;
      return pointIndex;
    },
  );
}
